import { Injectable } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Map } from 'immutable';
import {
  EMAIL_MAX_LENGTH,
  EMAIL_MAX_LENGTH_MULTIPLE,
  EmailService,
} from '../shared/services/email/email.service';
import { IMessageDeliveryData } from './message-delivery.interface';

@Injectable()
export class MessageDeliveryBuilder {
  FORM_KEYS = {
    BCC: 'bcc',
    CC: 'cc',
    FILENAME: 'fileName',
    INCLUDE_FOOTER: 'includeFooter',
    MESSAGE: 'message',
    SUBJECT: 'subject',
    TO: 'to',
  };

  constructor(
    private _formBuilder: FormBuilder,
    private _emailService: EmailService
  ) {}

  buildForm(
    defaultBCC: string,
    defaultCC: string,
    defaultMessage: string,
    defaultSubject: string,
    defaultTo: string,
    filename: string,
    includeFooter: boolean,
    disableEditing: boolean
  ): FormGroup {
    return this._formBuilder.group({
      [this.FORM_KEYS.BCC]: [
        defaultBCC,
        [
          Validators.maxLength(EMAIL_MAX_LENGTH),
          this.validateEmailFn.bind(this),
        ],
      ],
      [this.FORM_KEYS.CC]: [
        defaultCC,
        [
          Validators.maxLength(EMAIL_MAX_LENGTH),
          this.validateEmailFn.bind(this),
        ],
      ],
      [this.FORM_KEYS.FILENAME]: [filename],
      [this.FORM_KEYS.INCLUDE_FOOTER]: [includeFooter],
      [this.FORM_KEYS.MESSAGE]: [
        { value: defaultMessage, disabled: disableEditing },
      ],
      [this.FORM_KEYS.SUBJECT]: [
        { value: defaultSubject, disabled: disableEditing },
        Validators.required,
      ],
      [this.FORM_KEYS.TO]: [
        defaultTo,
        [
          Validators.required,
          Validators.maxLength(EMAIL_MAX_LENGTH_MULTIPLE),
          this.validateEmailFn.bind(this),
        ],
      ],
    });
  }

  buildMessageDeliveryData(
    formData: Map<string, any>,
    validForm: boolean,
    disableEditing: boolean,
    defaultMessage: string,
    defaultSubject: string
  ): IMessageDeliveryData {
    const formKeys = this.FORM_KEYS;

    return {
      bcc: formData.get(formKeys.BCC),
      cc: formData.get(formKeys.CC),
      fileName: formData.get(formKeys.FILENAME),
      includeFooter: formData.get(formKeys.INCLUDE_FOOTER),
      message: disableEditing
        ? defaultMessage
        : formData.get(formKeys.MESSAGE, defaultMessage),
      subject: disableEditing
        ? defaultSubject
        : formData.get(formKeys.SUBJECT, defaultSubject),
      to: formData.get(formKeys.TO),
      valid: validForm,
    };
  }

  validateEmailFn = (c: FormControl): any => {
    const isValid = this._emailService.validateEmails(c.value, true);

    return isValid
      ? null
      : {
          validEmail: { valid: false },
        };
  };
}
